import { render, staticRenderFns } from "./SideModalHeader.vue?vue&type=template&id=6036a77a&scoped=true&"
import script from "./SideModalHeader.vue?vue&type=script&lang=ts&"
export * from "./SideModalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SideModalHeader.vue?vue&type=style&index=0&id=6036a77a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036a77a",
  null
  
)

export default component.exports